import React, { Component } from 'react';
import { Collapse, Button, Card, CardBody, Col, Row } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';

class ManageTeam extends Component {

	constructor(props) {
		super(props);
		this.state = {
			content: this.props.manageTeamData,
			collapse: false,
			isApplyClass: false,
		};
		this.toggle = this.toggle.bind(this);
	}

	toggle() {
		this.setState({ collapse: !this.state.collapse, isApplyClass: !this.state.isApplyClass });
	}

	render() {
		return (

			<Row>
				<Col sm="12">
					<Button color="primary" className={this.state.isApplyClass ? 'show-dropdown-icon' : ''} onClick={this.toggle} style={{ marginBottom: '1rem' }} size={"sm"} block>Managing Your Team</Button>
					<Collapse isOpen={this.state.collapse}>
						<Card>
							<CardBody>
								{ReactHtmlParser(this.state.content)}
							</CardBody>
						</Card>
					</Collapse>
				</Col>
			</Row>
		);
	}
}

export default ManageTeam;
